

















import { Component, Vue, Prop, Inject } from 'vue-property-decorator'
import Menu from './Menu.vue'
import NavbarDropdownMenu from './NavbarDropdownMenu.vue'

@Component({
  components: { Menu, NavbarDropdownMenu },
})
export default class DrawerMenu extends Vue {
  @Prop()
  isOpened!: boolean

  @Inject('close-mobile-sidebar')
  toggleMenu!: () => void

  handleMenuClick(event: MouseEvent): void {
    const target = event.target as HTMLElement
    const label = target?.textContent?.trim() || target.querySelector('span:not(.icon)')?.textContent?.trim()
    if (label === this.$t('menu.manage_carried_device') || label === this.$t('menu.manage_fixed_device')) {
      return
    }

    // Close menu
    this.toggleMenu()
  }
}
